// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"145b8cbe","908":"145b8cbe"}[chunkId] + ".chunk.css";
};